import GameManager from './js/GameManager';

window.Game2048 = GameManager;